
let fileDownload = "http://localhost:5002/api/v1/download/"
const hostname = window.location.hostname;
// if (/^wrms.ohrange.in/.test(hostname)) {
//   fileDownload = 'https://api.wrms.ohrange.in/api/v1/download/'
// }
if (/^workhubmanager.co.in/.test(hostname)) {
  fileDownload = 'https://workhubmanager.co.in/api/v1/download/'
}

export const URLS = {
  createOrg: "create-org",
  login: "login",
  user: "user",
  auth: "auth",
  updatePassword: "update-password",
  forgetPassword:"forget-password",
  verifyOtp:"verify-opt",
  changePassword:"changePassword",
  manageProject: "manageProject",
  getProjectList: "getProjectList",
  searchEmployees: "searchEmployees",
  projectTeamManage: "projectTeamManage",
  getTeamsList: "getTeamsList",
  manageTeam: "manageTeam",
  getWorkReportEmpolyees: "getWorkReportEmpolyees",
  getActivities: "getActivities",
  getAssignedProjects: "getAssignedProjects",
  manageDailyStatus: "manageDailyStatus",
  getDailyStatus: "getDailyStatus",
  getTeamDailyStatus: "getTeamDailyStatus",
  getTeamAISummary: "getTeamAISummary",
  logout: "logout",
  addCandidate: "addCandidate",
  addOrUpdateJob: "addOrUpdateJob",
  getJobs: "getJobs",
  setJobStatus: "job-status",
  resumeUpload: "resumeUpload",
  getMyCandidates: "getMyCandidates",
  getAllCandidates: "getAllCandidates",
  getParticularCandidate: (ID) => `getParticularCandidate/${ID}`,
  getEmpoyees: "getEmpoyees",
  getEmpoyeesLight: "getEmpoyeesLight",
  addEmployee: "addEmp",
  updateEmployee: "updateEmp",
  schedule: "schedule",
  getInterViewData: (CID, IID, EID) => `getInterViewData/${CID}/${IID}/${EID}`,
  assignInterViewList: "assignInterViewList",
  updateReview: "updateReview",
  getLeaveTypes: "getLeaveTypes",
  createLeaveRequest: "createLeaveRequest",
  getTeamLevelLeaveRequest: "getTeamLevelLeaveRequest",
  updateLeaveRequestStatus: "updateLeaveRequestStatus",
  getMyLeaveRequests: "getMyLeaveRequests",
  updateLeaveRequest: "updateLeaveRequest",
  getDashboardData: "getDashboardData",
  getScheduledCandidates: "getScheduledCandidates",
  getSelectedCandidates: "getSelectedCandidates",
  getRejectedCandidates: "getRejectedCandidates",
  dashboardSummary: 'dashboard-summary',
  myAttendance: 'attendance/me',
  teamAttendance: 'attendance/team',
  attendanceCheckIn: 'attendance/check-in',
  attendanceCheckOut: 'attendance/check-out',
  attendanceHeartbeat: 'attendance/heartbeat',

  // performance reviews
  reviewAccess: 'review/access',
  reviewTemplates: 'review/templates',
  reviewCycles: 'review/cycles',
  reviewMine: 'review/mine',
  reviewTeam: 'review/team',
  reviewReport: 'review/report',
  reviewRemind: 'review/remind',
  reviewAudiences: 'review/audiences',
  contactEnquiry: 'contact-enquiry',
  updateProfile: 'updateProfile',
  completeProfile: 'complete-profile',
  profilePicture: 'profile-picture',
  getEmpWithSkills: 'getEmployeeCodeWithProjects',
  getTeamList: 'getTeamList',
  getProjectTeamList: 'getProjectTeamList',
  getEmployees: 'getEmpoyees',


  //notifications
  addNotificationEndPoints: 'addNotificationEndPoints',
  getMyNotifications: "getMyNotifications",
  updateNotificationReadStatus: "updateNotificationReadStatus",
  clearUnreadNotifications: "clearUnreadNotifications",
  getDashboardLeavesData: "getDashboardLeavesData",
  getDashboardCalendarData: (startDate, endDate) => `getDashboardCalendarData?startDate=${startDate}&endDate=${endDate}`,
  activeAccountOtpGenerate: "activeAccountOtpGenerate",
  activeAccount: "activeAccount",
  getDailyStatusdownload: 'getDailyStatusdownload',
  fileDownloadServer: fileDownload,

  //TimeSheet

  createTimesheet: 'createTimesheet',
  getTimeSheetData: (startDate, endDate) => `getTimeSheetData?startDate=${startDate}&endDate=${endDate}`,
  updateTimeSheet: 'timeSheet-approve',
  TeamTimeSheets: 'team-timeSheets',
  ApproveAll: 'approve-all',


  //Social-Feed && Chat

  createPost: "createPost",
  getAllPosts: "getAllPosts",
  getUserPosts: "getUserPosts",
  getPostById: "getPostById",
  likePost: "likePost",
  unlikePost: "unlikePost",
  commentPost: "commentPost",
  //Chat
  chatCategories: "chat/categories",
  chatCategoryMembers: (key) => `chat/categories/${key}/members`,
  chatConversations: "chat/conversations",
  chatOpenConversation: "chat/conversation",
  chatMessages: (id, before, limit = 30) =>
    `chat/conversation/${id}/messages?limit=${limit}${before ? `&before=${before}` : ''}`,
  chatMarkRead: (id) => `chat/conversation/${id}/read`,
  chatSendMessage: "chat/message",
  chatEditMessage: (id) => `chat/message/${id}`,
  chatDeleteMessage: (id) => `chat/message/${id}`,
  chatUploadImage: "chat/image",
  chatImage: (file) => `chat/image/${file}`,
  chatUnreadCount: "chat/unread-count",
  chatPresence: (codes) => `chat/presence?codes=${encodeURIComponent(codes.join(','))}`,
  chatPeople: (q) => `chat/people?q=${encodeURIComponent(q)}`,
  chatTeams: "chat/teams",
  chatSetTeamMembers: (key) => `chat/teams/${key}`,

  //Assistant
  assistantMessage: "assistant/message",
  assistantConfirm: (id) => `assistant/action/${id}/confirm`,
  assistantCancel: (id) => `assistant/action/${id}/cancel`,


  // Asset Management
  getAssetsList: "assets-list",
  createAsset: 'create-assets',
  updateEmpAssets: 'updateEmpAssets',
  assetModify: "asset-modify",
  removeAsset: "remove-asset",
  returnAsset: 'return-asset',

  // Help Desk
  helpDeskAccess: "helpdesk/access",
  myTickets: "helpdesk/my-tickets",
  allTickets: "helpdesk/tickets",
  createTicket: "helpdesk/ticket",
  updateTicket: "helpdesk/ticket",
  deleteTicket: "helpdesk/ticket",
  updateTicketStatus: "helpdesk/ticket-status",

  // Manage Employees
  updateEmployee: "employee",
  deleteEmployee: "employee",
  bulkUploadEmployees: "bulkUploadEmployees",
  bulkEmployeeTemplate: "bulkEmployeeTemplate"
};


